import { Link } from 'react-router-dom';
import ActionsMenu from '../../../shared/components/ActionsMenu';
import { getActions } from '../../actions';
import { formatFecha, getEstadoChipStyle } from '../../utils';
import PiezasList from '../PiezasList';

const CHIP_EXTRA = {
    padding: '3px 11px',
    borderRadius: '20px',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 600,
    display: 'inline-block',
};

const SolicitudAlternativaTableRow = ({ item, onAction }) => (
    <tr>
        <td>
            <div className="fw-semibold" style={{fontSize: '14px'}}>
                {item.id}
            </div>
            <div>
                {formatFecha(item.created_at)}
            </div>
        </td>
        <td>
            <div style={{ fontSize: '14px' }}>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    to={`/presupuesto/${item.origen?.id ?? ''}`}
                    title="Ficha presupuesto"
                    className="text-primary fw-bold"
                >
                    {item.origen?.numero ?? '-'}
                </Link>
            </div>
            <div>{formatFecha(item.origen?.fecha)}</div>
        </td>
        <td>
            <div className="fw-semibold" style={{ fontSize: '14px' }}>
                {item.origen?.entidad?.nombre ?? '-'}
            </div>
            <div>{item.origen?.entidad?.telefono ?? '-'}</div>
        </td>
        <td>
            <PiezasList
                piezas={item.piezas ?? []}
                variant="origen"
                showPrecioVenta={false}
            />
        </td>
        <td className="text-center">{item.motivo?.nombre ?? '-'}</td>
        <td className="text-uppercase text-center">
            {item.origen?.created_by?.username ?? '-'}
        </td>
        <td className="text-uppercase text-center">
            {item?.crafted_by?.username || '-'}
        </td>
        <td className="text-center" style={{ minWidth: '140px' }}>
            <div
                className="text-center"
                style={{
                    ...getEstadoChipStyle(item.estado?.id),
                    ...CHIP_EXTRA,
                }}
            >
                {item.estado?.estado ?? '-'}
            </div>
        </td>
        <td className="text-center">
            <ActionsMenu
                options={getActions(item.estado.id, item?.crafted_by)}
                onAction={(action) => onAction(action, item)}
            />
        </td>
    </tr>
);

export default SolicitudAlternativaTableRow;
